
import ravenAngularPlugin from 'raven-js/plugins/angular';

window.Raven.addPlugin(ravenAngularPlugin, angular)
.install();


export default ravenAngularPlugin.moduleName;



// WEBPACK FOOTER //
// ./src/common/wrappers/raven.js